import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { LaborCategory } from 'app/domain';
import { LaborReasonService } from '../labor-reason.service';

@Injectable({ providedIn: 'root' })
export class LaborCategoriesResolver
  implements Resolve<Observable<LaborCategory[]>> {
  constructor(private laborReasonService: LaborReasonService) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<LaborCategory[]> {
    return this.laborReasonService.getLaborCategories();
  }
}
